import React from 'react';
import type { FC } from 'react';
import { Backdrop, Box, Stack, keyframes } from '@mui/material';
import { Logo } from "../logo";
import Lottie from "lottie-react";
import animationData from "./lottie/loading.json"; // <-- metti qui il tuo file

// Definizione animazioni con keyframes
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

interface LoadingOperationProps {
  visible: boolean;
}

const MyLoadingOperation: FC<LoadingOperationProps> = ({ visible }) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 9999 ,
        backgroundColor: 'rgba(255,255,255,0.3)', // leggero overlay
        backdropFilter: 'blur(8px)',              // <-- effetto blur
        WebkitBackdropFilter: 'blur(8px)',        // <-- supporto Safari
      }}
      open={visible}
    >
      <Stack
        direction="column"
        spacing={2}
        sx={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <Box
          sx={{
            animation: `${fadeIn} 2s infinite`,
          }}
        >
          {/* <Logo isSingle={false} height={148} width={550}/> */}

          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: 350, height: 350 }}
          />
        </Box>
      </Stack>
    </Backdrop>
  );
};

export default MyLoadingOperation;
